import { render, staticRenderFns } from "./ServiceOrder.vue?vue&type=template&id=83295d0a&scoped=true"
import script from "./ServiceOrder.vue?vue&type=script&lang=js"
export * from "./ServiceOrder.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrder.vue?vue&type=style&index=0&id=83295d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83295d0a",
  null
  
)

export default component.exports